import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Divider, Row, Form, Button, Input, Switch, notification, Col, DatePicker, Select, Tag } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { Link } from 'react-router-dom'
import { CountdownTimer } from '../../components/CountdownTimer'
const INIT = {
    name: '',
    last_name: '',
    email: '',
    // password: '',
    // password_confirm: '',
    role_id: null,
    boss_id: null,
    active: true,
    subsidiaries: [],
    work_start_date: '',
}
const { Option } = Select

const UsersEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [subsidiaries, setSubsidiaries] = React.useState([])
    const [currentSearchBoss, setCurrentSearchBoss] = React.useState('')
    const [currentSearchRole, setCurrentSearchRole] = React.useState('');

    const [isTokenValid, setIsTokenValid] = useState(false);
    const [token, setToken] = useState(null);

    const disabled =
        !data.name ||
        !data.last_name ||
        !data.email ||
        !data.role_id ||
        !data.subsidiaries.length ||
        !data.work_start_date

    const getSubsidiaries = async () => {
        return API.get('/api/subsidiaries?pagination=false&filter[active]=1')
            .then(response => {
                setSubsidiaries(response.data)
            })
            .catch(error => {
                console.error('Error en obtener las sucursales', error)
            })
    }
    const getData = async () => {
        return API.get(`/api/users/${match.params.id}`)
            .then(response => {
                const newData = { ...response.data }
                if (response.data.role) {
                    setCurrentSearchRole(response.data.role.name)
                }

                if (response.data.boss) {
                    setCurrentSearchBoss(response.data.boss.name)
                }

                if (response.data.boss) {
                    setCurrentSearchBoss(response.data.boss.name)
                }

                if (response.data.subsidiaries) {
                    newData.subsidiaries = response.data.subsidiaries.map(item => {
                        return { key: item.id, label: item.name }
                    })
                }
                setData(newData)
            })
            .catch(error => {
                console.error('Error en obtener el usuario', error)
            })
    }

    useEffect(() => {
        async function fetchRequests() {
            try {
                setloading(true);
                await Promise.all([getData(), getSubsidiaries()]);
            } finally {
                setloading(false);
            }
        }
        fetchRequests();
    }, [])

    useEffect(() => {
        if (data.id) {
            fetchToken(data.id);
        }
    }, [data.id]);

    const save = e => {
        e.preventDefault()
        setloading(true);

        const newData = { ...data };
        Object.keys(newData).forEach((k) => !newData[k] && delete newData[k]);
        newData.active = !!newData.active;
        newData.work_start_date = moment(data.work_start_date).format('YYYY/MM/DD');
        API.patch(`/api/users/${match.params.id}`, newData)
            .then(() => {
                setloading(false)
                notification.success({
                    message: 'El usuario se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                if (error.response && error.response.data && error.response.data.message) {
                    notification.error({
                        message: error.response.data.message[0],
                    })
                }
            })
    }

    // const generateToken = (chars, len) => [...Array(len)].map(
    //     () => chars[Math.floor(Math.random() * chars.length)],
    //  ).join('');

     const generateToken = async () => {
        try {
            setloading(true);
            const response = await API.get(`/api/tokens/user/${data.id}/generate`);
            const { ok, message, payload } = response.data;
            notification.success({ message });
            setToken(payload);
            setIsTokenValid(true);
        } catch (e) {
            if (e.response) {
                notification.error({ message });
            } else if (e.request) {
                notification.error({ message: 'No se recibió respuesta del servidor' });
            } else {
                notification.error({ message: e.message || ' Error desconocido de JS' });
            }
        } finally {
            setloading(false);
        }
     };

     const fetchToken = async (userId) => {
        try {
            setloading(true);
            const response = await API.get(`/api/tokens/user/${userId}`);
            const { ok, message, payload } = response.data;
            notification.success({ message });
            setToken(payload.token);
            setIsTokenValid(payload.is_valid);
        } catch (e) {
            console.error('Error al obtener el token', e);
            const message = 'Error al obtener el token. ';
            if (e.response) {
                notification.error({ message });
            } else if (e.request) {
                notification.error({ message: 'No se recibió respuesta del servidor' });
            } else {
                notification.error({ message: e.message || ' Error desconocido de JS' });
            }
        } finally {
            setloading(false);
        }
     }

    return (
        <Segment loading={loading}>
            <Divider>Editar usuario</Divider>
            <Form style={{ maxWidth: '800px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>
                <Row gutter={24}>
                <Col lg={3} md={12} sm={24}>
                        <Form.Item label="ID" >
                            <Input
                                placeholder="ID"
                                value={data.id}
                                disabled
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={9} md={12} sm={24}>
                        <Form.Item label="Nombre" className="required" hasFeedback>
                            <Input
                                placeholder="Nombre"
                                value={data.name}
                                required
                                onChange={e => {
                                    setData({ ...data, name: e.target.value.toUpperCase() })
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Apellido" className="required" hasFeedback>
                            <Input
                                placeholder="Apellido"
                                value={data.last_name}
                                onChange={e => {
                                    setData({ ...data, last_name: e.target.value.toUpperCase() })
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Correo" className="required" hasFeedback>
                            <Input
                                placeholder="Correo"
                                value={data.email}
                                type="email"
                                onChange={e => {
                                    setData({ ...data, email: e.target.value.toLocaleLowerCase() })
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Contraseña" className="required" hasFeedback>
                            <Input
                                placeholder="Contraseña"
                                type="password"
                                value={data.password}
                                onChange={e => {
                                    setData({ ...data, password: e.target.value })
                                }}
                            />
                        </Form.Item>
                        <Form.Item label="Confirmar" className="required" hasFeedback>
                            <Input
                                placeholder="Confirmar contraseña"
                                type="password"
                                value={data.password_confirmation}
                                onChange={e => {
                                    setData({ ...data, password_confirmation: e.target.value })
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item className="required" label="Perfil">
                            <Search
                                value={currentSearchRole}
                                placeholder="Perfil"
                                onSearch={value => `/api/roles?filter[active]=1&filter[name]=${value}`}
                                onChange={(key, value) => {
                                    setData({ ...data, role_id: key })
                                    setCurrentSearchRole(value.name)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Jefe directo">
                            <Search
                                value={currentSearchBoss}
                                placeholder="Jefe directo"
                                onSearch={value => `/api/users?filter[active]=1&filter[full_name]=${value}`}
                                label="full_name"
                                onChange={(key, value) => {
                                    setData({ ...data, boss_id: key })
                                    setCurrentSearchBoss(value.full_name)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Sucursal" className="required">
                    <Select
                        mode="multiple"
                        showSearch
                        labelInValue
                        value={data.subsidiaries}
                        placeholder="Sucursal"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={value => {
                            console.log(value)
                            setData({ ...data, subsidiaries: value })
                        }}
                        style={{ width: '100%' }}
                    >
                        {subsidiaries.map(d => (
                            <Option key={d.id} value={d.id} selected>
                                {d.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Fecha de ingreso laboral" className="required">
                            <DatePicker
                                required
                                value={moment(data.work_start_date)}
                                format="MM/DD/YYYY"
                                onChange={value => {
                                    setData({ ...data, work_start_date: value })
                                }}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Activo" hasFeedback sx={{ display: 'flex' }}>
                            <Switch
                                checked={!!data.active}
                                onChange={(checked)  => {
                                    const newValue = checked;
                                    setData(prevData => {
                                      const newData = { ...prevData };
                                      newData['active'] = newValue;
                                      return newData;
                                    });
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Token" className="required">
                            <Input
                                readOnly
                                placeholder="Token"
                                value={token && token.value}
                            />
                        </Form.Item>
                        {!isTokenValid && <Tag color="red">Vencido</Tag>}
                        {isTokenValid && <Tag color="green">Vigente</Tag>}
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Generar">
                            <Button
                                type="primary"
                                // onClick={() => setData({ ...data, token: generateToken('0123456789', 6) })}
                                onClick={generateToken}
                            >
                                Generar token
                            </Button>
                        </Form.Item>
                        <Tag color="blue">Vence en: </Tag>
                        {token && (
                            <Tag>
                                <CountdownTimer
                                    onExpiration={() => setIsTokenValid(false)}
                                    targetDate={moment(token.expires_at).valueOf()}
                                />
                            </Tag>
                        )}
                    </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/users">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={save}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>


            </Form>
        </Segment>
    )
}

export default UsersEditContainer
